export const planFeaturesFieldsStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: '#23252F',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '8px 24px',
    width: '100%',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  label: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: '#23252F',
  },
};
